import { Box, Paper, Typography } from '@mui/material';

import { useCallback, useState } from 'react';

import { Loader } from 'common/components/Loader/Loader';
import CommonTable from 'common/components/Table/CommonTable';
import { Column } from 'common/components/Table/CommonTableStyles';
import AlertComponent from 'common/components/ToastMessage/ToastMessage';

import { ITestResultsTableData } from 'features/TestMonitoring/api/type-def';

import styles from './TestResults.module.scss';

const TestResultsTable = ({ processesTableData }: any) => {
	const [toastMessage, setToastMessageLocal] = useState('');
	const [isLoading] = useState<boolean>(false);
	const [isToastOpen, setIsToastOpen] = useState(false);
	const handleToast = useCallback(() => {
		setIsToastOpen(false);
		setToastMessageLocal('');
	}, []);

	const columns: readonly Column[] = [
		{
			id: 'testPlanName',
			label: 'Test Plan',
			disablePadding: false,
			isSortable: true,
			render: (params: ITestResultsTableData) => (
				<Typography
					component="div"
					data-testid="phaseid-link"
					className={`${styles['remediation-table-task-name']} ${params.testPlanName.length}> 30 ? ${styles['remediation-table-task-name-wrap']} : ''}`}
				>
					{params?.testPlanName ? params?.testPlanName : '--'}
				</Typography>
			),
		},
		{
			id: 'testAreaName',
			label: 'Test Area',
			disablePadding: false,
			isSortable: true,
			render: (params: ITestResultsTableData) => (
				<div>{params?.testAreaName ? params?.testAreaName : '--'}</div>
			),
		},
		{
			id: 'testRecord',
			label: 'Test Record',
			disablePadding: false,
			isSortable: true,
			render: (params: ITestResultsTableData) => (
				<div>{params?.testRecord ? params?.testRecord : '--'}</div>
			),
		},
		{
			id: 'testType',
			label: 'Test Type',
			disablePadding: false,
			isSortable: true,
			render: (params: ITestResultsTableData) => (
				<div>{params?.testType ? params?.testType : '--'}</div>
			),
		},
		{
			id: 'testResult',
			label: 'Test Results',
			disablePadding: false,
			isSortable: true,
			render: (params: ITestResultsTableData) => (
				<div>{params?.testResult ? params?.testResult : '--'}</div>
			),
		},
		{
			id: 'totalSampleSizeTested',
			label: 'Total Sample Size Tested',
			disablePadding: false,
			isSortable: true,
			render: (params: ITestResultsTableData) => (
				<div>
					{params?.totalSampleSizeTested ? params?.totalSampleSizeTested : '--'}
				</div>
			),
		},
		{
			id: 'totalSampleFailed',
			label: 'Number of Samples Failed',
			disablePadding: false,
			isSortable: true,
			render: (params: ITestResultsTableData) => (
				<div>
					{params?.totalSampleFailed ? params?.totalSampleFailed : '--'}
				</div>
			),
		},
		{
			id: 'totalSampleWithObservations',
			label: 'Number of Samples with Observations',
			disablePadding: false,
			isSortable: true,
			render: (params: ITestResultsTableData) => (
				<div>{params.totalSampleWithObservations || '--'}</div>
			),
		},
	];
	return (
		<Box data-testid="testResult" className={styles['processes-table-box']}>
			{processesTableData && processesTableData.length > 0 && !isLoading ? (
				<CommonTable
					id="TestResultTable"
					rows={processesTableData}
					columns={columns}
					defaultSortKey=""
					tableStyles={{ minWidth: 750, maxHeight: 440 }}
				/>
			) : (
				<div>
					{!isLoading ? (
						<Paper className={styles['processes-table-loading-box']}>
							<Typography data-testid="no-data-found">No data found</Typography>
						</Paper>
					) : (
						<Paper className={styles['processes-table-loading-box']}>
							<Loader show={false} />
						</Paper>
					)}
				</div>
			)}
			<AlertComponent
				open={isToastOpen}
				toastMessage={toastMessage}
				severity="error"
				handleCloseMessage={handleToast}
				vertical="top"
				horizontal="right"
			/>
		</Box>
	);
};

export default TestResultsTable;
